/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recent_ProjectsInputs */

const en_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Projects`)
};

const fr_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets récents`)
};

const de_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Projekte`)
};

const it_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetti recenti`)
};

const ru_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недавние проекты`)
};

const es_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyectos recientes`)
};

const zh_cn2_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期项目`)
};

const ja_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近のプロジェクト`)
};

const hi_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल की परियोजनाएँ`)
};

const pt_pt2_recent_projects = /** @type {(inputs: Recent_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projetos recentes`)
};

/**
* | output |
* | --- |
* | "Recent Projects" |
*
* @param {Recent_ProjectsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const recent_projects = /** @type {((inputs?: Recent_ProjectsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recent_ProjectsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_recent_projects(inputs)
	if (locale === "de") return de_recent_projects(inputs)
	if (locale === "it") return it_recent_projects(inputs)
	if (locale === "ru") return ru_recent_projects(inputs)
	if (locale === "es") return es_recent_projects(inputs)
	if (locale === "zh-CN") return zh_cn2_recent_projects(inputs)
	if (locale === "ja") return ja_recent_projects(inputs)
	if (locale === "hi") return hi_recent_projects(inputs)
	if (locale === "pt-PT") return pt_pt2_recent_projects(inputs)
	return en_recent_projects(inputs)
});